import * as React from 'react';
import EDIconButton from '../../IconButton/EDIconButton';
import { CommonPropsAndTypes } from '../../../_Types/StandardComponentProps';

interface IProps {
  onClick: () => void;
  tooltip?: string;
  disabled?: boolean;
  disabledReason?: string;
  noLeftMargin?: boolean;
  noRightMargin?: boolean;
  noTopMargin?: boolean;
  noBottomMargin?: boolean;
  color?: CommonPropsAndTypes.ColorType;
}

/**
 * En knapp menad för att gå framåt i samma sammanhang
 */
const EDForwardChevron: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) => {
  const { tooltip = 'Nästa', ...rest } = props;
  return (
    <EDIconButton
      color={props.color && undefined}
      tooltip={tooltip}
      {...rest}
      icon="chevron_right"
    />
  );
};

export default EDForwardChevron;
